import { EntityHolisticlock } from "../../entity/EntityHolisticlock";

export class DtoHolisticlocksPutRes extends EntityHolisticlock {}
